import {NgModule, Optional, SkipSelf} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import { downgradeInjectable } from '@angular/upgrade/static';
import { MatDialogModule } from '@angular/material/dialog';

import {
    ApiServiceProvider,
    AuthServiceProvider,
    LoginServiceProvider,
    ModalServiceProvider,
    LoaderServiceProvider,
    SocketServiceProvider,
    LocalStorageServiceProvider,
    TutorialProvider,
    MapUtilsServiceProvider,
    BadgeGeneratorServiceProvider,
    RouteSegmentServiceProvider,
    WorldActivatorServiceProvider,
    ConstantsServiceProvider
} from './upgraded-providers';

import { XPayStationWidgetService } from './XPayStationWidget.service';
import { DlgWelcomeComponent  } from './dlg-welcome.component';
import { DlgTipsComponent } from './dlg-tips.component';
import { ShowDlgWorldRespawnService } from './show-dlg-world-respawn.service';

import { TipsComponent } from './tips.component';
import { WelcomeComponent } from './welcome.component';

declare const angular: angular.IAngularStatic;

@NgModule({
    imports: [
        ReactiveFormsModule,
        MatDialogModule,

        SharedModule,
        RouterModule,
        // Dependencies modules
    ],
    declarations: [
        TipsComponent,
        WelcomeComponent,
        DlgWelcomeComponent,
        DlgTipsComponent
    ],
    exports: [
        ReactiveFormsModule
    ],
    providers: [
        ApiServiceProvider,
        AuthServiceProvider,
        LoginServiceProvider,
        ModalServiceProvider,
        XPayStationWidgetService,
        TutorialProvider,
        LoaderServiceProvider,
        RouteSegmentServiceProvider,
        LocalStorageServiceProvider,
        SocketServiceProvider,
        MapUtilsServiceProvider,
        BadgeGeneratorServiceProvider,
        WorldActivatorServiceProvider,
        ConstantsServiceProvider,
        ShowDlgWorldRespawnService
    ],
    entryComponents: [
        DlgWelcomeComponent,
        DlgTipsComponent
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        // if (parentModule) {
        //     throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        // }
    }
}

angular.module('app')
    .factory('ShowDlgWorldRespawnService', downgradeInjectable(ShowDlgWorldRespawnService) as any);
